<template>
  <div class="header">
    <h1>{{ title }}</h1>
    <h2>Find out which games you and your friends have in common.</h2>
  </div>
</template>

<script>
export default {
  name: "Logo",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-size: 2em;
  margin: 0;
  text-align: center;
}
h2 {
  font-size: 1em;
  color: grey;
  font-weight: 200;
  margin: 0;
  text-align: center;
}
.header {
  margin-bottom: 2em;
}
</style>